import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';

@Component({
  selector: 'lib-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
})
export class EditPhoneComponent implements AfterViewInit {
  @Input() formGroup: {
    controls: {
      phoneNumber: FormControl<string>;
      phoneNumberRaw: FormControl<string>;
      extension: FormControl<string>;
    };
  };
  @Input() label: string;
  @Input() required: boolean;
  @Input() isSmallLabel: boolean = false;
  @ViewChild(NgxMatIntlTelInputComponent) intlTelComponent;

  ngAfterViewInit(): void {
    setTimeout(() => {
      const strippedValue = cleanPhoneNumber(this.formGroup.controls.phoneNumber.value);
      this.formGroup.controls.phoneNumberRaw.setValue(strippedValue); // This is a workaround for the issue where the phone number is not set correctly.
      this.formGroup.controls.phoneNumberRaw.valueChanges.subscribe((_) => {
        this.setNumberToDbFormattedNumber();
      });
    }, 0);
  }

  private setNumberToDbFormattedNumber() {
    if (!this.intlTelComponent) return;
    const numberValue =
      this.intlTelComponent.selectedCountry.dialCode === '1'
        ? this.intlTelComponent.formattedPhoneNumber
        : this.intlTelComponent.value; // Include country code and unformatted phone number
    if (this.formGroup.controls.phoneNumber.value !== numberValue) {
      this.formGroup.controls.phoneNumber.setValue(numberValue);
    }
  }

  displayLabel = () => {
    return this.isSmallLabel ? '' : 'bigLabel';
  };
}

export const cleanPhoneNumber = (formattedNumber: string) => {
  if (!formattedNumber) {
    return formattedNumber;
  }
  const stripped = formattedNumber.replace(/([^\+0-9]+)/g, '');
  return stripped[0] === '+' ? stripped : `+1${stripped}`;
};
